import { motion } from "framer-motion";
import Image from "next/legacy/image";
import React from "react";
import { CheckEligibility, RepresentativeText } from "utils/constants";

import FadeIn from "./common/FadeInEffect";

function SimplifyCreditComponent() {
  return (
    <div className="max-w-[1156px] 4xl:max-w-[1500px] m-auto md:px-10 xl:px-0 grid lg:grid-cols-2 lg:gap-2 xl:gap-16 lg:grid-flow-col grid-flow-row md:items-start text-onmoText lg:my-auto">
      <div className="order-2 lg:order-1">
        <div className="relative m-auto lg:m-0 hidden 4xl:block">
          <motion.div
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 50,
              transition: {
                duration: 0,
              },
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
          >
            <div className="w-[633px] h-[403px] bg-gradient-to-b from-transparent to-onmoPurple-250  border-[1px] border-onmoPurple-500 rounded-2xl " />
          </motion.div>
          <motion.div
            variants={{
              hidden: { opacity: 1, x: -50, y: 50 },
              visible: { opacity: 1, x: 50, y: 0 },
            }}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="absolute top-0 m-auto"
          >
            <Image
              src="/images/onmo-credit.png"
              alt="Onmo Credit"
              width={633}
              height={403}
              objectFit="contain"
              loading="lazy"
            />
          </motion.div>
        </div>
        <div className="relative m-auto hidden xl:block 4xl:hidden">
          <motion.div
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 40,
              transition: {
                duration: 0,
              },
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
          >
            <div className="w-[463px] h-[295px] bg-gradient-to-b from-transparent to-onmoPurple-250  border-[1px] border-onmoPurple-500 rounded-2xl " />
          </motion.div>
          <div className="absolute top-0">
            <motion.div
              variants={{
                hidden: { opacity: 1, x: -50, y: 50 },
                visible: { opacity: 1, x: 40, y: 0 },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className=" md:mb-4"
            >
              <Image
                src="/images/onmo-credit.png"
                alt="Onmo Credit"
                width={463}
                height={295}
                objectFit="contain"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
        <div className="relative m-auto hidden lg:block xl:hidden">
          <motion.div
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 30,
              transition: {
                duration: 0,
              },
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
          >
            <div className="w-[363px] h-[231px] bg-gradient-to-b from-transparent to-onmoPurple-250  border-[1px] border-onmoPurple-500 rounded-2xl " />
          </motion.div>
          <div className="absolute top-0">
            <motion.div
              variants={{
                hidden: { opacity: 1, x: -50, y: 50 },
                visible: { opacity: 1, x: 30, y: 0 },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <Image
                src="/images/onmo-credit.png"
                alt="Onmo Credit"
                width={363}
                height={231}
                objectFit="contain"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
        <div className="relative m-auto hidden md:block lg:hidden">
          {/** Tablet */}
          <motion.div
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 20,
              transition: {
                duration: 0,
              },
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
          >
            <div className="w-[287px] h-[183px] bg-gradient-to-b from-transparent to-onmoPurple-250  border-[1px] border-onmoPurple-500 rounded-2xl " />
          </motion.div>
          <div className="absolute top-0">
            {/** Tablet */}
            <motion.div
              variants={{
                hidden: { opacity: 1, x: 0, y: 50 },
                visible: { opacity: 1, x: 20, y: 0 },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <Image
                src="/images/onmo-credit.png"
                alt="Onmo Credit"
                width={287}
                height={183}
                objectFit="contain"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
        <div className="relative m-auto hidden sm:flex justify-center md:hidden ">
          {/** Mobile Bg rectangle */}
          <motion.div
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 20,
              transition: {
                duration: 0,
              },
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
          >
            <div className="w-[284px] h-[189px] bg-gradient-to-b from-transparent to-onmoPurple-250  border-[1px] border-onmoPurple-500 rounded-2xl " />
          </motion.div>
          <div className="absolute top-0">
            {/**Mobile */}
            <motion.div
              variants={{
                hidden: { opacity: 1, x: -50, y: 50 },
                visible: { opacity: 1, x: 20, y: 0 },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <Image
                src="/images/onmo-credit.png"
                alt="Onmo Credit"
                width={284}
                height={189}
                objectFit="contain"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
        <div className="relative m-auto sm:hidden flex justify-center ">
          <motion.div
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 20,
              transition: {
                duration: 0,
              },
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
          >
            <div className="w-[247px] h-[165px] bg-gradient-to-b from-transparent to-onmoPurple-250  border-[1px] border-onmoPurple-500 rounded-2xl " />
          </motion.div>
          <div className="absolute top-0">
            <motion.div
              variants={{
                hidden: { opacity: 1, x: -50, y: 50 },
                visible: { opacity: 1, x: 20, y: 0 },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <Image
                src="/images/onmo-credit.png"
                alt="Onmo Credit"
                width={247}
                height={165}
                objectFit="contain"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
        <div className="xs:mx-5 mt-12 lg:hidden">
          <CheckEligibility />
          <RepresentativeText />
        </div>
      </div>
      <div className=" w-full relative mx-auto lg:my-0 lg:ml-0 text-center lg:text-left order-1 lg:order-2 px-6 sm:px-0">
        <FadeIn>
          <h2 className="text-size-6 leading-11 lg:text-6xl 3xl:text-size-9 4xl:text-size-11 4xl:leading-124 mb-6 3xl:mb-8 4xl:mb-10 font-normal font-ppNeue">
            Your credit.
            <br /> Simplified.
          </h2>
        </FadeIn>
        <FadeIn>
          <p className="text-base justify-center mb-2 3xl:mb-6 4xl:mb-spacing-9/2 md:mb-4 lg:text-xl 3xl:text-size-4 4xl:text-size-4/5 font-normal flex gap-3 lg:w-auto mx-auto lg:justify-start items-center h-8">
            <Image
              src="/images/circle-right.svg"
              alt="APR"
              width={26}
              height={26}
              loading="lazy"
            />
            39.9% APR representative variable
          </p>
        </FadeIn>
        <FadeIn>
          <p className="text-base justify-center lg:text-xl 3xl:text-size-4 mb-spacing-9/2 3xl:mb-spacing-12 4xl:text-size-4/5 font-normal flex gap-3 lg:w-auto mx-auto lg:justify-start items-center h-8">
            <Image
              src="/images/circle-right.svg"
              alt="Credit limit"
              width={26}
              height={26}
              loading="lazy"
            />
            Credit limit between £500 and £2,000
          </p>
        </FadeIn>
        <div className="hidden lg:block ">
          <CheckEligibility />
          <RepresentativeText />
        </div>
      </div>
    </div>
  );
}

export default SimplifyCreditComponent;
